import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { AppConfig } from "./app-config.service";
@Injectable({
    providedIn: 'root'
})

export class userManagerService {
    httpOptions = {
        headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    };
    apiUrl = AppConfig.settings.apiUrl;
    constructor(private http: HttpClient) {

    }

    public getUserManagerData(searchKeyWord : any){
        return (
        this.http.get<any>(`${this.apiUrl}UserManagement/all?searchKeyword=${searchKeyWord}`,  this.httpOptions));
    }   

    public downloadUserlistExcel(){
       return this.http.get(`${this.apiUrl}UserManagement/export`, { 'responseType' : 'blob' })
       
    }

    public getDefaultList(){
        return  this.http.get<any>(`${this.apiUrl}usermanagement/GroupChanges/getGroupChangeDropdownOptions`,this.httpOptions);
    }

    public getConfig(){
        return (
            this.http.get<any>(`${this.apiUrl}usermanagement/Config`,  this.httpOptions));    
    }

    public saveConfig(payload:any){
        return (
            this.http.post<any>(`${this.apiUrl}usermanagement/Config`,payload,this.httpOptions)
        )
    }

    public deleteConfig(){
        return (
            this.http.delete<any>(`${this.apiUrl}usermanagement/Config`,this.httpOptions)
        )
    }

    public getroleDropdown(){
        return (
            this.http.get<any>(`${this.apiUrl}usermanagement/Config`,  this.httpOptions)); 
    }

    public changeRoleOfUser(payload : any){
        return (
            this.http.post<any>(`${this.apiUrl}usermanagement/GroupChanges`,payload,this.httpOptions)
        )
    }

}